import React from "react";
import "./Footer.css"; // Estilos personalizados
import { FaInstagram, FaFacebook, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      {/* Línea separadora encima del footer */}
      <div className="footer-separator"></div>
      
      <footer className="footer">
        <div className="footer-logo">
          <img src="/logo12.jpg" alt="Deluxe Labs Logo" />
        </div>
        <div className="footer-socials">
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="social-icon" />
          </a>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="social-icon" />
          </a>
        </div>
        <p className="footer-text">&copy; 2024 Deluxe Labs. Todos los derechos reservados.</p>
      </footer>

      {/* Botón flotante de WhatsApp */}
      <div className="whatsapp-floating-button">
        <a
          href="https://wa.me/+56965296123?text=Hola,%20necesito%20ayuda"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="whatsapp-icon" />
        </a>
      </div>
    </>
  );
};

export default Footer;
